import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import Seo, { breadcrumbLd } from '../components/Seo';
import { MaskedLines, FadeUp, Eyebrow } from '../components/motion';
import { useT } from '../i18n/LangContext';
import { useContent } from '../data/useContent';

export default function BlogPage() {
  const t = useT();
  const { BLOG_POSTS } = useContent();

  return (
    <>
      <Seo title={t['seo.blog.title']} description={t['seo.blog.desc']}
        jsonLd={[breadcrumbLd(['Home', 'Blog'])]} />
      <section className="bg-ink pb-28 pt-16 md:pt-24">
        <div className="container-site">
          <Eyebrow>{t['bl.eyebrow']}</Eyebrow>
          <MaskedLines as="h1" className="mt-4 font-serif text-4xl font-semibold leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl"
            lines={[{ text: t['bl.h1a'], cls: 'text-white' }, { text: t['bl.h1b'], cls: 'italic text-gold' }]} />
          <div className="mt-14 grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {BLOG_POSTS.map((p, i) => (
              <FadeUp key={p.slug} delay={i * 0.08}>
                <Link data-testid={`blog-card-${p.slug}`} to={`/blog/${p.slug}`} className="group block">
                  <div className="overflow-hidden rounded-xl">
                    <img src={p.img} alt={p.title} loading="lazy" className="photo-treat aspect-[16/10] w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  </div>
                  <p className="mt-5 text-xs font-bold uppercase tracking-[0.2em] text-gold">{p.category} · {p.date}</p>
                  <h2 className="mt-2 font-serif text-2xl font-semibold leading-snug text-white transition-colors group-hover:text-gold">{p.title}</h2>
                  <p className="mt-2 text-sm leading-relaxed text-silver">{p.excerpt}</p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-gold">{t['bl.read']} <ArrowUpRight className="h-4 w-4" /></span>
                </Link>
              </FadeUp>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
